// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"867":"4c5015b3","2091":"4c5015b3","3575":"ce044c50","4935":"08d55499","6641":"4c5015b3","6782":"4c5015b3"}[chunkId] + ".chunk.css";
};